module.exports = __webpack_public_path__ + "img/1565666747.ec64b4dd.jpg";